import React, { useState } from 'react';
import { apiService } from '../../utils/api';

function AdminProfile({ user }) {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    username: user.username,
    email: user.email,
    password: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (formData.password && formData.password !== formData.confirmPassword) {
      setMessage({ type: 'error', text: 'Passwords do not match' });
      return;
    }

    try {
      const updateData = {
        username: formData.username,
        email: formData.email
      };

      if (formData.password) {
        updateData.password = formData.password;
      }

      const response = await apiService.updateProfile(updateData);

      if (response.data.success) {
        setMessage({ type: 'success', text: 'Profile updated successfully' });
        // Update local storage with new user data
        const updatedUser = { ...user, ...updateData };
        delete updatedUser.password;
        localStorage.setItem('user', JSON.stringify(updatedUser));
        setIsEditing(false);
      } else {
        setMessage({ type: 'error', text: response.data.message || 'Update failed' });
      }
    } catch (err) {
      setMessage({ 
        type: 'error', 
        text: err.response?.data?.message || 'Error updating profile' 
      });
      console.error(err);
    }
  };

  return (
    <div className="admin-profile profile-section">
      <div className="profile-header">
        <h2>Administrator Profile</h2>
        <button 
          className="edit-button"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? 'Cancel' : 'Edit Profile'}
        </button>
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      {isEditing ? (
        <form onSubmit={handleSubmit} className="profile-form">
          <div className="form-group">
            <label>Username:</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>New Password (leave blank to keep current):</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password:</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="save-button">Save Changes</button>
        </form>
      ) : (
        <div className="profile-info">
          <div className="info-group">
            <span className="label">Username:</span>
            <span className="value">{user.username}</span>
          </div>
          <div className="info-group">
            <span className="label">Email:</span>
            <span className="value">{user.email}</span>
          </div>
          <div className="info-group">
            <span className="label">Role:</span>
            <span className="value">Administrator</span>
          </div>
          <div className="info-group">
            <span className="label">Account Created:</span>
            <span className="value">{new Date(user.createdAt).toLocaleDateString()}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminProfile;